// PhoneFrame — wraps an image to look like a modern phone screen
// Uses CSS to draw a rounded device bezel + notch around any image src.

export default function PhoneFrame({
    src,
    alt = "App screen",
    className = "",
    tone = "light", // light or dark bezel
    testId,
}) {
    const bezel = tone === "dark" ? "bg-[#1a1a1a]" : "bg-[#2D2D2D]";
    const innerBg = "bg-[#FDF6EE]";

    return (
        <div
            data-testid={testId}
            className={`relative inline-block ${className}`}
        >
            {/* Bezel */}
            <div
                className={`relative ${bezel} rounded-[3rem] p-[10px] shadow-[0_30px_60px_-15px_rgba(45,45,45,0.45)]`}
            >
                {/* Inner screen */}
                <div
                    className={`relative ${innerBg} rounded-[2.4rem] overflow-hidden aspect-[9/19] w-[270px] md:w-[300px]`}
                >
                    {/* Notch */}
                    <div className="absolute top-2 left-1/2 -translate-x-1/2 w-24 h-5 rounded-full bg-[#1a1a1a] z-20" />
                    {/* Screen image — object-cover keeps content focused */}
                    <img
                        src={src}
                        alt={alt}
                        className="absolute inset-0 w-full h-full object-cover"
                        loading="lazy"
                    />
                </div>
            </div>
        </div>
    );
}
